import axios from '../../utils/axiosConfig';
import { Contexture } from './Contexture';

const BASE_URL = `${process.env.REACT_APP_LAMBDA_API_URL}/contexture/notification`;

export class Notification {
  static async getPreferences(params) {
    try {
      const response = await axios.get(`${BASE_URL}/preferences`, {
        headers: Contexture.getHeaders(),
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }

  static async updatePreferences(data, params) {
    try {
      const response = await axios.post(`${BASE_URL}/preferences`, data, {
        headers: {
          ...Contexture.getHeaders(),
          'Content-Type': 'application/json',
        },
        params,
      });

      return response.data;
    } catch (err) {
      throw err;
    }
  }
}
